import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import Fuse from 'fuse.js';
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

import { TextInputField, DropDownField, AutoCompleteField, CalendarField, Button, TextAreaField } from "../../helpers";
import Loading from '../../common/Loading';
import FileViewAndRemove from '../../common/FileViewAndRemove';

import { fetchTicketCategory, fetchTicketSubCategory, fetchTicketStatus, fetchTicketGroupAssignee, fetchTicketSubCategoryParams, fetchTicketConstraintAssignees, fetchTicketConstraintCategories, fetchCalendarHolidays } from "../../services/redux/reducers/commonThunk";
import { addTicket } from '../../services/api/tickets'
import { getBuyerCompanies } from '../../services/api/tickets';
import { getCompanyBranchesByCompanyId } from '../../services/api/tickets';
import { getFollowerList } from '../../services/api/tickets';
import { uploadFile } from '../../services/api/company';
import { raiseToast } from "../../services/redux/reducers/toast/toast";

import { TicketAddValidation, ticketAddInitialState, } from '../../validation/ticketValidation';
import { getUploadedFileObj, sortArrayOfObjectsInAlphabeticalOrder, validateInputs } from '../../utils';

import "./index.css"


const TicketAdd = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    let ticketCategories = useSelector(state => state.common.ticketCategories)
    let ticketSubCategoies = useSelector(state => state.common.ticketSubCategories)
    let ticketSubCategoryParams = useSelector(state => state.common.ticketSubCategoryParams)
    let ticketGroupAssignee = useSelector(state => state.common.ticketGroupAssignee)
    let ticketConstraintAssignees = useSelector(state => state.common.ticketConstraintAssignees)
    let ticketConstraintCategories = useSelector(state => state.common.ticketConstraintCategories)
    let calendarHolidays = useSelector(state => state.common.calendarHolidays)

    const userDetails = useSelector(state => state.userDetails)
    const PMCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const userId = userDetails?.userId
    const usersList = userDetails?.PMCompanyDetails?.companyUsers
    const activeUserRoleDetails = useSelector((state) => state.userDetails.activeUserRoleDetails)

    const [ ticketObj, setTicketObj ] = useState(ticketAddInitialState)
    const [ searchedAssigneeNames, setSearchedAssigneeNames ] = useState([])
    const [ selectedAssignee, setSelectedAssignee ] = useState()

    const [ searchedFollowerNames, setSearchedFollowerNames ] = useState([])
    const [ selectedFollower, setSelectedFollower ] = useState()
    const [ ticketSubCategoryList, setTicketSubCategoryList ] = useState([])

    const [ userList, setUserList ] = useState([])
    const [ formErrors, setFormErrors ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(false)
    const [ uploadedFileView, setUploadedFileView ] = useState(false)
    const [ uploadedFile, setUploadedFile ] = useState({})
    const [ defaultAssigneeUsers, setDefaultAssigneeUsers ] = useState([])
    const [subCategoryParams, setSubCategoryParams] = useState([])
    const [ticketParamValues, setTicketParamValues] = useState({})
    const [paramErrors, setParamErrors] = useState({});
    const [buyerCompanies, setBuyerCompanies] = useState([])
    let [isTicketAssigneeFieldHide, setIsTicketAssigneeFieldHide] = useState(false)
    const [companySuggestions, setCompanySuggestions] = useState([])
    const [companyName, setCompanyName] = useState(null)
    const [selectedBranchId, setSelectedBranchId] = useState(null)
    const [selectedCompanyId, setSelectedCompanyId] = useState(null)
    const [companyBranches, setCompanyBranches] = useState([])
    const [selectedCategories, setSelectedCategories] = useState([])
    const [selectedAssigneeList, setSelectedAssigneeList] = useState([])
    const [selectedFollowerList, setSelectedFollowerList] = useState([])
    const [procmartUser, setProcmartUser] = useState(true)
    const [calendarHolidaysList, setCalendarHolidaysList] = useState([])
    const [pmBranchList, setPmBranchList] = useState([])

    const priority = [
        { label: 'Urgent', value: 'URGENT' },
        { label: 'High', value: 'HIGH' },
        { label: 'Medium', value: 'MEDIUM' },
        { label: 'Low', value: 'LOW' }
    ]
    ticketObj.ticketDefaultAssignees = defaultAssigneeUsers
    ticketObj["ticketParamValues"] = ticketParamValues
    ticketObj.companyId = selectedCompanyId
    ticketObj.branchId = selectedBranchId

    if(!procmartUser){
        ticketObj["companyId"] = activeUserRoleDetails?.companyId
        ticketObj["branchId"] = activeUserRoleDetails?.branchId
    }

    const getRelatedPmBranches = (userId) => {
        const relatedPmUser = PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === userId)
        if (!relatedPmUser){
            return []
        }
        return relatedPmUser.userRoles.filter(eachRole => eachRole.statusId === 1).map(eachRole => eachRole.branchId)
    }

    useEffect(() => {
        if (!selectedAssignee) {
            setTicketObj(prevState => ({ ...prevState, pmBranchId: null }))
            setPmBranchList([])
            return
        }
    
        let assigneePMBranchIds = getRelatedPmBranches(selectedAssignee.id)

        let filteredPmBranches = []
        if (assigneePMBranchIds.includes(0) || assigneePMBranchIds.length === 0) {
            filteredPmBranches = PMCompanyDetails.companyBranches
        } else {
            filteredPmBranches = PMCompanyDetails.companyBranches.filter(eachCompanyBranch =>
                assigneePMBranchIds.includes(eachCompanyBranch.branchId)
            )
        }

        if(filteredPmBranches.length === 1){
            setTicketObj({...ticketObj, pmBranchId: filteredPmBranches[0].branchId})
        }
    
        setPmBranchList(filteredPmBranches)
    }, [selectedAssignee])

    useEffect(() => {
        setProcmartUser(activeUserRoleDetails?.companyId === PMCompanyDetails.companyId)
        if (ticketCategories && ticketCategories.length > 0) {
            const relatedCompanyId = activeUserRoleDetails?.companyId
            const relatedCategoriesId = ticketConstraintCategories?.filter(each => each?.companyId === relatedCompanyId)?.map(each => each.ticketCategoryId)
            const filteredCategories = ticketCategories?.filter(category => relatedCategoriesId?.includes(category.ticketCategoryId))
            setSelectedCategories(filteredCategories)
        }
    }, [ticketCategories, activeUserRoleDetails, ticketConstraintCategories]);

    useEffect(()=> {

        dispatch(fetchTicketCategory(true))
        dispatch(fetchTicketSubCategory(true))
        dispatch(fetchTicketStatus(true))
        dispatch(fetchTicketGroupAssignee(true))
        dispatch(fetchTicketSubCategoryParams(true))
        dispatch(fetchTicketConstraintAssignees(true))
        dispatch(fetchTicketConstraintCategories(true))
        dispatch(fetchCalendarHolidays(true))
        getBuyerCompaniesList()

        const currentDate = new Date();
        let dueDate = currentDate.setDate(currentDate.getDate() +  2)
        dueDate = new Date(dueDate)
        ticketObj['ticketDueDate'] = dueDate

        ticketObj.ticketPriority = "MEDIUM"

    }, [])
    
    useEffect(()=>{
        setSelectedBranchId(null)
        if(selectedCompanyId){
            getCompanyBranches(selectedCompanyId)
        }

    },[selectedCompanyId])
    
    useEffect(()=>{
        if(calendarHolidays && calendarHolidays?.length >0){
            const holidays = calendarHolidays?.map(each => each?.holidayDate)
            setCalendarHolidaysList(holidays)
        }

    },[calendarHolidays])
    
    const isHoliday = (date) => {
        return calendarHolidaysList?.includes(date.toISOString().split('T')[0])
    }
    
    const getNextWorkingDay = (date) => {
        date.setDate(date.getDate() + 1)
    
        if (date.getDay() === 6) {
            date.setDate(date.getDate() + 2)
        }
        else if (date.getDay() === 0) {
            date.setDate(date.getDate() + 1)
        }
    
        if (isHoliday(date)) {
            return getNextWorkingDay(date)
        }
        return date
    }
    
    useEffect(()=> {
        const relatedSubCat = ticketSubCategoryList?.find(eachSubCategory => eachSubCategory.ticketSubcategoryId == ticketObj.ticketSubcategoryId)
        
        let requiredHours = 0
        if (relatedSubCat && relatedSubCat.priority && relatedSubCat.defaultDueHours && relatedSubCat.defaultDueHours[relatedSubCat.priority]) {
            let dueDate = new Date()
            requiredHours = relatedSubCat.defaultDueHours[relatedSubCat.priority]
            while (requiredHours > 0) {
                const currentDay = dueDate.getDay()
                const isSunday = currentDay === 0
                const isSaturday = currentDay === 6
                const shiftStartHour = 10
                const shiftEndHour = isSaturday ? 18 : 19

                if (dueDate.getHours() < shiftStartHour) {
                    dueDate.setHours(shiftStartHour, 0, 0, 0)
                }

                if (isSunday) {
                    dueDate.setDate(dueDate.getDate() + 1)
                    dueDate.setHours(10, 0, 0, 0)
                    continue
                }
                
                if (dueDate.getHours() >= shiftEndHour) {
                    dueDate.setDate(dueDate.getDate() + 1)
                    dueDate.setHours(10, 0, 0, 0)
                    continue
                }
                
                if (dueDate.getHours() < shiftStartHour) {
                    dueDate.setHours(shiftStartHour, 0, 0, 0)
                }
                

                const currentTime = dueDate.getTime()
                const shiftEndTime = new Date(dueDate)
                shiftEndTime.setHours(shiftEndHour, 0, 0, 0)
                const diffMs = shiftEndTime.getTime() - currentTime
                const remainingTodayHours = diffMs / (1000 * 60 * 60)

                if (remainingTodayHours >= requiredHours) {
                    dueDate.setTime(currentTime + requiredHours * 60 * 60 * 1000)
                    break
                } else {
                    requiredHours -= remainingTodayHours
                    dueDate.setDate(dueDate.getDate() + 1)
                    dueDate.setHours(10, 0, 0, 0)
                }
            }

            ticketObj['ticketDueDate'] = dueDate
        }
        
        if (relatedSubCat?.defaultAssignee){
            const relatedGroupUser = userList.find(each => each.id == relatedSubCat?.defaultAssignee)
            setSelectedAssignee(relatedGroupUser)
            ticketObj["ticketAssignee"] = relatedGroupUser?.id
            const ticketGroupAssigneeUserIds = ticketGroupAssignee?.filter(each => each?.groupUserId === relatedGroupUser?.id)?.map(each => each?.userId)
            setDefaultAssigneeUsers(ticketGroupAssigneeUserIds)
            setIsTicketAssigneeFieldHide(true)
        } else{
            setSelectedAssignee(null)
            ticketObj["ticketAssignee"] = null
            setDefaultAssigneeUsers([])
            setIsTicketAssigneeFieldHide(false)
        }
    
        if(relatedSubCat?.emailAlerts){
            ticketObj.ticketEmailAlerts = true
        } else{
            ticketObj.ticketEmailAlerts = false
        }
    
        const relatedSubCategoryParams = ticketSubCategoryParams?.filter(each =>{
            if(each?.ticketSubcategoryId === ticketObj.ticketSubcategoryId){
                return each
            }
        })
        setSubCategoryParams(relatedSubCategoryParams)
        setTicketParamValues({})
        ticketObj["ticketParamValues"] = null
        setParamErrors({})
        if (ticketConstraintAssignees) {
            const relatedAssignessIds = ticketConstraintAssignees
                .filter(each => each?.ticketSubcategoryId === ticketObj?.ticketSubcategoryId)
                .map(each => each?.userId);
            const filteredAssignees = userList?.filter(eachAssignee => relatedAssignessIds?.includes(eachAssignee?.id))
            setSelectedAssigneeList(filteredAssignees)
        }
        getConstraintFollowerList()

        if(relatedSubCat && relatedSubCat.priority){
            ticketObj.ticketPriority = relatedSubCat.priority
        }
        else{
            ticketObj.ticketPriority = null
        }
    }, [ticketObj.ticketSubcategoryId])
    
    useEffect(()=> {

        if(usersList?.length > 0){
            getUsersList()
        }

    }, [usersList])

    const getBuyerCompaniesList = async ()=>{
        const buyerCompanyRes = await getBuyerCompanies()
        // console.log('buyerCompanyRessssssss',buyerCompanyRes)
        if(buyerCompanyRes?.data?.length !== 0){
            const addCompanyOption = {}
            
            let updatedCompanyData = _.uniqBy(buyerCompanyRes?.data, "companyId")
            updatedCompanyData = sortArrayOfObjectsInAlphabeticalOrder(updatedCompanyData, 'companyName')
            setBuyerCompanies(updatedCompanyData)
        }

    }

    const getConstraintFollowerList = async ()=>{
        const data = {
            subCategoryId : ticketObj?.ticketSubcategoryId,
            companyId : activeUserRoleDetails?.companyId
        }
        const constraintFollower = await getFollowerList(data)
        if (!constraintFollower?.failure){
            setSelectedFollowerList(constraintFollower?.data)
        }
    }

    const getCompanyBranches = async ()=>{
        const companyBranchRes = await getCompanyBranchesByCompanyId(selectedCompanyId)
        if(companyBranchRes.failure){
            return dispatch(raiseToast({severity:'error', summary: 'Company Branches Error', detail: companyBranchRes.data.error, life: 3000}))
        }
        if (companyBranchRes.data.length !== 0){
            setCompanyBranches(companyBranchRes.data)
            if(companyBranchRes.data.length === 1){
                setSelectedBranchId(companyBranchRes.data[0].branchId)
            }
        }
    }

    const companySearchMethod = (event) => {
        if(event.query === ""){
            setCompanySuggestions([...buyerCompanies])
        }
        else{
            const searchResults = companyFuzzSearch.search(event.query)
            const relatedCompanies = searchResults.map(eachProduct => eachProduct.item)
            setCompanySuggestions(relatedCompanies)
        }
    }

    const companyFuzzSearch = useCallback(new Fuse(buyerCompanies, {
        keys: ['companyName'],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true, 
        getFn: (obj) => {
            return obj.companyName.replace(/\s+/g, '')
        },
    }), [buyerCompanies])

    const handleCompanyChange = (e) => {
        //setCompanyBranches([])
        if (e.target.value && typeof e.target.value === 'object') {
            setCompanyName(e.target.value.companyName);
            setSelectedCompanyId(e.target.value.companyId);
        } else {
            setCompanyName(e.target.value);
            setSelectedCompanyId(null);
        }
    };
    const handleBranchChange = (e) => {
        setSelectedBranchId(e.target.value)
    };

    const handlePmBranchChange = (e) => {
        setTicketObj(prevState => ({ ...prevState, pmBranchId: e.target.value }))
    }

    const extractMaxLength = (paramDataType) => {
        const matches = paramDataType.match(/\((\d+)\)/);
        return matches ? parseInt(matches[1]) : null;
    };

    const handleParamChange = (e, paramName, paramDataType) => {
        const paramValue = e.target.value
        const lowerParamDataType = paramDataType.toLowerCase()
        const maxLength = extractMaxLength(paramDataType)
        let errorMessage = ''

        const updatedParamValues = {
            ...ticketParamValues,
            [paramName]: paramValue
        }
        if (['numeric', 'int', 'integer', 'docno', 'reqno', 'buyerpono', 'sellerpono', 'sellerpino', 'vpno', 'buyerinvoiceno'].includes(lowerParamDataType)) {
            if (isNaN(paramValue)) {
                errorMessage = `${paramName} must be numeric`
            } else {
                switch (lowerParamDataType) {
                    case 'docno':
                        if (![11, 15, 16].includes(paramValue.length)) {
                            errorMessage = `${paramName} should be either 11, 15, or 16 digits`
                        }
                        break
                    case 'reqno':
                        if (!paramValue.startsWith("11")) {
                            errorMessage = `${paramName} must start with 11`
                        } else if (paramValue.length !== 15) {
                            errorMessage = `${paramName} should be exactly 15 digits`
                        }
                        break
                    case 'buyerpono':
                        if (!paramValue.startsWith("14")) {
                            errorMessage = `${paramName} must start with 14`
                        } else if (paramValue.length !== 15) {
                            errorMessage = `${paramName} should be exactly 15 digits`
                        }
                        break
                    case 'sellerpono':
                        if (!paramValue.startsWith("15")) {
                            errorMessage = `${paramName} must start with 15`
                        } else if (paramValue.length !== 15) {
                            errorMessage = `${paramName} should be exactly 15 digits`
                        }
                        break
                    case 'sellerpino':
                        if (!paramValue.startsWith("16")) {
                            errorMessage = `${paramName} must start with 16`
                        } else if (paramValue.length !== 15) {
                            errorMessage = `${paramName} should be exactly 15 digits`
                        }
                        break
                    case 'vpno':
                        if (!paramValue.startsWith("19")) {
                            errorMessage = `${paramName} must start with 19`
                        } else if (paramValue.length !== 15) {
                            errorMessage = `${paramName} should be exactly 15 digits`
                        }
                        break
                    case 'buyerinvoiceno':
                        if (!paramValue.startsWith("20")) {
                            errorMessage = `${paramName} must start with 20`
                        }
                        break
                    default:
                        break
                }
            }
        }
        else if (lowerParamDataType.startsWith('varchar')) {
            if (paramValue.length > maxLength) {
                errorMessage = `Maximum length for ${paramName} is ${maxLength}`
            }
        }
    
        setTicketParamValues(updatedParamValues)
        setParamErrors({ ...paramErrors, [paramName]: errorMessage })
    }

    const getUsersList = async () => {

        const usersData = usersList

        let userList = []

        usersData.map((data) => {

            // const userDetails = data.user

            const userDetails = data

            if(userDetails){

                let userName =  userDetails.firstName

                if(userDetails.lastName){
                    userName  = userName + " " + userDetails.lastName
                }

                const userObj = {
    
                    id: userDetails.userId,
                    firstName : userDetails.firstName,
                    lastName : userDetails.lastName,
                    name : userName,
                    statusId: userDetails.statusId
                }

                userList.push(userObj)
            }
        })

        userList = userList.sort(function (a, b) {
            if (a.name < b.name) {
                return -1
            }
            if (a.name > b.name) {
                return 1
            }
            return 0
        })

        setUserList(userList)
    }


    const saveTicket = async () => {

        ticketObj.ticketCreatedBy = userId

        const validationRes = await validateInputs(TicketAddValidation, ticketObj)
        if (subCategoryParams?.length !== 0) {
            let newParamErrors = {}
    
            subCategoryParams.forEach(eachParam => {
                const paramName = eachParam.paramName
                const paramValue = ticketObj.ticketParamValues[paramName] || ''
                const paramLength = paramValue.length
                const lowerParamDataType = eachParam.paramDataType.toLowerCase()
    
                if (eachParam.mandatory && !paramValue) {
                    newParamErrors[paramName] = `${paramName} is required.`
                }
                else if (['docno', 'reqno', 'buyerpono', 'sellerpono', 'sellerpino', 'vpno', 'buyerinvoiceno'].includes(lowerParamDataType)) {
                    if (isNaN(paramValue)) {
                        newParamErrors[paramName] = `${paramName} must be numeric.`
                    } else {
                        switch (lowerParamDataType) {
                            case 'docno':
                                if (![11, 15, 16].includes(paramLength)) {
                                    newParamErrors[paramName] = `${paramName} should be either 11, 15, or 16 digits.`
                                }
                                break
                            case 'reqno':
                                if (!paramValue.startsWith("11")) {
                                    newParamErrors[paramName] = `${paramName} must start with 11.`
                                } else if (paramLength !== 15) {
                                    newParamErrors[paramName] = `${paramName} should be exactly 15 digits.`
                                }
                                break
                            case 'buyerpono':
                                if (!paramValue.startsWith("14")) {
                                    newParamErrors[paramName] = `${paramName} must start with 14.`
                                } else if (paramLength !== 15) {
                                    newParamErrors[paramName] = `${paramName} should be exactly 15 digits.`
                                }
                                break
                            case 'sellerpono':
                                if (!paramValue.startsWith("15")) {
                                    newParamErrors[paramName] = `${paramName} must start with 15.`
                                } else if (paramLength !== 15) {
                                    newParamErrors[paramName] = `${paramName} should be exactly 15 digits.`
                                }
                                break
                            case 'sellerpino':
                                if (!paramValue.startsWith("16")) {
                                    newParamErrors[paramName] = `${paramName} must start with 16.`
                                } else if (paramLength !== 15) {
                                    newParamErrors[paramName] = `${paramName} should be exactly 15 digits.`
                                }
                                break
                            case 'vpno':
                                if (!paramValue.startsWith("19")) {
                                    newParamErrors[paramName] = `${paramName} must start with 19.`
                                } else if (paramLength !== 15) {
                                    newParamErrors[paramName] = `${paramName} should be exactly 15 digits.`
                                }
                                break
                            case 'buyerinvoiceno':
                                if (!paramValue.startsWith("20")) {
                                    newParamErrors[paramName] = `${paramName} must start with 20.`
                                }
                                break
                            default:
                                break
                        }
                    }
                }
            })
            setParamErrors(newParamErrors)
        } else {
            setParamErrors({})
        }
        if(selectedCompanyId && !selectedBranchId){
            return dispatch(raiseToast({severity:'error', summary: 'Error!', detail: 'Please select branch.',  life: 3000}))
        }
        if (validationRes.error || Object.values(paramErrors).some(error => error !== '')) {
            if (validationRes.error) {
                setFormErrors(validationRes.error);
                if(validationRes.error.ticketDescription){
                    return dispatch(raiseToast({severity:'error', summary: 'Error!', detail: validationRes.error.ticketDescription, life: 3000}))
                }
            }
        }else{
            let newTicketData = validationRes.result
            const relatedSubCat = ticketSubCategoryList.find(eachSubCategory => eachSubCategory.ticketSubcategoryId == ticketObj.ticketSubcategoryId)
            const validPriorities = ["URGENT", "HIGH", "MEDIUM", "LOW"]
            if(relatedSubCat.priority){
                if (!validPriorities.includes(relatedSubCat.priority)) {
                    return dispatch(raiseToast({severity: 'error', detail: `Invalid priority found for subcategory: "${relatedSubCat.subcategoryName}". Please contact tech team.`, life: 3000}))
                }
        
                const relatedDueHours = relatedSubCat.defaultDueHours[relatedSubCat.priority]
                if (!relatedDueHours) {
                    return dispatch(raiseToast({severity: 'error', detail: `Due hours not found for subcategory: "${relatedSubCat.subcategoryName}". Please contact tech team.`,life: 3000}))
                }
            }

            setFormErrors(prevState => ({}))
            setTicketObj(prevState => (newTicketData))
            if(window.confirm("This will add ticket do you want to proceed?")){
                setIsLoading(true)
                if(Object.values(uploadedFile).length > 0){
                    newTicketData['ticketDocument'] = ''
                    newTicketData['uploadFile'] = uploadedFile
                    insertTicket(newTicketData)
                }
                else {
                    insertTicket(newTicketData)
                }
            }
        }
    }

    const insertTicket = async (ticketUpdatedObj) => {
        const response = await addTicket(ticketUpdatedObj)
        setIsLoading(false)
        console.log("Added Ticket =>", response)
        if(!response.failure){
            const newTicket = response?.data?.data
            setTicketObj(ticketAddInitialState)
            setSelectedAssignee(null)
            setSelectedFollower(null)
            setUploadedFile(prevState => ({}))
            setIsLoading(false)
            return dispatch(raiseToast({severity:'success', summary: 'Add Ticket', detail: 'Ticket Added Successfully', life: 3000}))
        }else{
            return dispatch(raiseToast({severity:'error', summary: 'Add Ticket', detail: response.data.error, life: 3000}))
        }
    }


    const handleChange = (event) => {

        ticketObj[event.target.name] = event.target.value
        
        if(event.target.name == "ticketCategoryId"){
            ticketObj.ticketAssignee = null
            ticketObj.ticketSubcategoryId = null
            setParamErrors({})

            ticketSubCategoies = ticketSubCategoies.filter(obj => obj.categoryId == event.target.value)
            ticketSubCategoies = ticketSubCategoies.sort((a, b) => {
                if (a.subcategoryName.toLowerCase() < b.subcategoryName.toLowerCase()) return -1
                if (a.subcategoryName.toLowerCase() > b.subcategoryName.toLowerCase()) return 1
                return 0
            })

            setTicketSubCategoryList(ticketSubCategoies)

            if(ticketSubCategoies.length === 1){
                ticketObj.ticketSubcategoryId = ticketSubCategoies[0].ticketSubcategoryId
            }

            /*if(parseInt(event.target.value) === 2){
                ticketObj["ticketAssignee"] = 18766

                const relatedAsignee = userList.find(eachUser => eachUser.id === 18766)
                setSelectedAssignee(relatedAsignee)
            }*/
            ticketObj["ticketDueDate"] = null
        }

        setTicketObj({...ticketObj})
    }
    

    const handleAssigneeChange = (event) => {
        setSelectedAssignee(event.value)

        ticketObj["ticketAssignee"] = event.value?.id
        
        setTicketObj({...ticketObj})
    }

    const handleFollowerChange = (event) => {
        setSelectedFollower(event.value)

        const followers = event.value
        const followerIds = [] 
        if(activeUserRoleDetails?.companyId === PMCompanyDetails.companyId){
            followers?.map((follower) => {
                followerIds.push(follower.id)
            })
        }else{
            followers?.map((follower) => {
                followerIds.push(follower.userId)
            })
        }

        ticketObj['ticketFollower'] = followerIds

        setTicketObj({...ticketObj})
    }

    const searchAssignee = (event) => {
        const query = event.query.toLowerCase().trim();
        let assigneeList = selectedAssigneeList.length > 0 ? selectedAssigneeList:  userList
        
        assigneeList = assigneeList.filter(eachAsignee => eachAsignee.statusId === 1)

        let _filteredAssigneeUsers = !query.length 
            ? [...assigneeList]
            : assigneeList.filter((user) => {
                const fullName = `${user.firstName} ${user.lastName}`.toLowerCase()
                return fullName.includes(query)
            })
        setSearchedAssigneeNames(_filteredAssigneeUsers)
        setTicketObj(prevState => ({ ...prevState, pmBranchId: null }))

    }

    const searchFollower = (event) => {
        const query = event.query.toLowerCase().trim();
        const follwerList = activeUserRoleDetails?.companyId === PMCompanyDetails.companyId ? userList : selectedFollowerList;
    
        const _filteredFollowerUsers = !query.length 
            ? [...follwerList]
            : follwerList.filter((user) => {
                const fullName = `${user.firstName} ${user.lastName}`.toLowerCase()
                return fullName.includes(query)
            })
    
        setSearchedFollowerNames(_filteredFollowerUsers)
    }

    const documentUploadHandler = async ({ files, options }, doc_name) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, allowedFileTypes: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]

        setUploadedFile(prevState => ({
            url: fileObj.objectURL,
            documentName: doc_name,
            fileName: fileObj.name,
            dataURI: fileObj.dataURI,
            inputName: fileObj.inputName,
            objectURL: fileObj.objectURL
        }))
        
        ticketObj[fileObj.inputName] = fileObj.dataURI
        setTicketObj({ ...ticketObj })
    }


    const uploadTicketDocument = async (doc_name, file_name, data_uri, input_name) => {

        let data = {
            doc_name,
            file_name,
            data_uri
        }
        setIsLoading(true)
        let response = await uploadFile(data)
        console.log("upload-file-response ==>", response)
        if (response.status) {
            ticketObj[input_name] = response.data
            setTicketObj({ ...ticketObj })
            setIsLoading(false)
        }

        return response
    }


    const removeTicketDocument = () => {

        ticketObj.ticketDocument = ""
        setTicketObj({ ...ticketObj })
        setUploadedFile({})
    }


    // console.log("ticketObj --> ", ticketObj)

    const maxDueDate = new Date(new Date().setMonth(new Date().getMonth() + 1))

    return (

        <div className='add-ticket-container'>
            <div className='p-card'>
            <Toast ref={Toast} />
            <div className='flex flex-row justify-content-between'>
                <div>
                    <h5 className="m-2 mb-0">Add Ticket</h5>  
                </div>
                <div className='flex justify-content-end'>
                    <Button className="small-btn action-btn hover:surface-400 hover:text-700 surface-300" onClick={() => navigate(`/tickets`)} label="Back" />
                </div>
            </div>
            <div className="grid m-2">
                <div className="flex flex-wrap col-12 pl-0">
                    <div className="flex flex-column col-12 mb-2 md:col-4a lg:col-6 lg:mb-0">
                        <TextInputField name="ticketName" labelText="Ticket Title"   value={ticketObj.ticketName} onChange={(e) => handleChange(e)} required errorMessage={formErrors.ticketName} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-2 lg:mb-0">
                        <DropDownField name="ticketCategoryId" labelText="Category" options={activeUserRoleDetails?.companyId === PMCompanyDetails.companyId ? ticketCategories : selectedCategories} optionLabel="categoryName" optionValue="ticketCategoryId" value={ticketObj.ticketCategoryId} onChange={(event) => handleChange(event)} required errorMessage={formErrors.ticketCategoryId} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-2 lg:mb-0">
                        <DropDownField name="ticketSubcategoryId" labelText="SubCategory" options={ticketSubCategoryList} optionLabel="subcategoryName" optionValue="ticketSubcategoryId" value={ticketObj.ticketSubcategoryId} onChange={(event) => handleChange(event)} required errorMessage={formErrors.ticketSubcategoryId} />
                    </div>
                    <div className="flex flex-column col-12 mb-2  md:col-2 lg:col-2 lg:mb-0">
                        <DropDownField name="ticketPriority" labelText="Priority" options={priority} optionLabel="label" optionValue="value" value={ticketObj.ticketPriority} onChange={(event) => handleChange(event)} required errorMessage={formErrors.ticketPriority} />
                    </div>
                </div>
                <div className="flex flex-wrap col-12 pl-0 pt-0">
                    <div className="flex flex-column col-12 mb-2 md:col-4 lg:col-3 lg:mb-0">
                        <AutoCompleteField labelText="Assignee" field="name" placeholder="Search assignee" value={selectedAssignee} suggestions={searchedAssigneeNames} searchMethod={searchAssignee} onChange={(event) => handleAssigneeChange(event)} required dropdown forceSelection errorMessage={formErrors.ticketAssignee} disabled={isTicketAssigneeFieldHide}/>
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-1 lg:col-2 lg:mb-0">
                        <CalendarField name="ticketDueDate"  labelText="Due Date" showTime showIcon placeholder="" minDate={new Date()} maxDate={maxDueDate} value={ticketObj.ticketDueDate}  onChange={(event) => handleChange(event)} required errorMessage={formErrors.ticketDueDate}/>
                    </div>
                    {
                        procmartUser ? (
                            <>
                                <div className="flex flex-column col-12 md:col-3 lg:col-3 lg:mb-0 post-req-autocomplete company">
                                    <AutoCompleteField dropdown name="company" labelText="Buyer Company" field="companyName" value={companyName} searchMethod={companySearchMethod} suggestions={companySuggestions} onChange={handleCompanyChange} dropdownButtonClassName="styled-autocomplete-dropdown-button" errorMessage={formErrors.companyId} forceSelection />
                                </div>
                                <div className="flex flex-column col-12 md:col-3 lg:col-2 lg:mb-0 post-req-autocomplete company">
                                    <DropDownField dropdown name="branch" labelText="Branch" value={selectedBranchId} optionValue="branchId" optionLabel="branchName" options={companyBranches} onChange={handleBranchChange} />
                                </div>
                            </>
                        ) : null
                    }
                    <div className="flex flex-column col-12 md:col-3 lg:col-2 lg:mb-0">
                        <DropDownField dropdown name="branch" labelText="Pm Branch" value={ticketObj.pmBranchId} optionValue="branchId" optionLabel="branchName" options={pmBranchList} onChange={handlePmBranchChange} errorMessage={formErrors.pmBranchId} required/>
                    </div>
                </div>
                <div className="flex flex-column col-12 mb-2 md:col-12 lg:col-12 lg:mb-0">
                    <AutoCompleteField customFieldStyle={{minheight:"34px" }} labelText="Follower" field="name" selectionLimit={5} placeholder="Search follower" value={selectedFollower} suggestions={searchedFollowerNames} searchMethod={searchFollower}  multiple onChange={(event) => handleFollowerChange(event)} dropdown forceSelection errorMessage={formErrors.ticketFollower} />
                </div>

                {subCategoryParams &&
                    subCategoryParams
                        .reduce((acc, _, index) => (index % 3 === 0 ? acc.concat([subCategoryParams.slice(index, index + 3)]) : acc), [])
                        .map((subParamGroup, rowIndex) => (
                            <div key={rowIndex} className="flex flex-wrap col-12 pl-0 pt-0">
                                {subParamGroup.map((param) => (
                                    <div key={param.subCategoryParamsId} className={`flex flex-column col-12 mb-2 md:col-4 lg:col-4 lg:mb-0`}>
                                        {['numeric', 'int', 'integer', 'var', 'varchar', 'docno', 'reqno', 'buyerpono','sellerpono','sellerpino','vpno','buyerinvoiceno'].includes(param.paramDataType.toLowerCase())? (
                                            <TextInputField
                                                name={param.paramName}
                                                labelText={param.paramName}
                                                value={ticketParamValues[param.paramName] || ''}
                                                onChange={(e) => handleParamChange(e, param.paramName, param.paramDataType)}
                                                required={param.mandatory}
                                                keyfilter="pnum"
                                                errorMessage={paramErrors[param.paramName]}
                                            />
                                        ) : ['date'].includes(param.paramDataType.toLowerCase()) ? (
                                            <CalendarField
                                                name={param.paramName}
                                                labelText={param.paramName}
                                                value={ticketParamValues[param.paramName] || ''}
                                                onChange={(e) => handleParamChange(e, param.paramName, param.paramDataType)}
                                                required={param.mandatory}
                                                errorMessage={paramErrors[param.paramName]}
                                            />
                                        ) : ['datetime'].includes(param.paramDataType.toLowerCase()) ? (
                                            <CalendarField
                                                dateFormat='dd/mm/yy'
                                                name={param.paramName}
                                                labelText={param.paramName}
                                                value={ticketParamValues[param.paramName] || ''}
                                                onChange={(e) => handleParamChange(e, param.paramName, param.paramDataType)}
                                                showTime hourFormat="12" showIcon
                                                required={param.mandatory}
                                                errorMessage={paramErrors[param.paramName]}
                                            />
                                        ) : ['text'].includes(param.paramDataType.toLowerCase()) ? (
                                            <TextAreaField
                                                name={param.paramName}
                                                labelText={param.paramName}
                                                value={ticketParamValues[param.paramName] || ''}
                                                onChange={(e) => handleParamChange(e, param.paramName, param.paramDataType)}
                                                required={param.mandatory}
                                                errorMessage={paramErrors[param.paramName]}
                                            />
                                        ) : ['bool', 'boolean'].includes(param.paramDataType.toLowerCase()) ? (
                                            <DropDownField
                                                name={param.paramName}
                                                labelText={param.paramName}
                                                options={[
                                                    { label: 'True', value: 'true' },
                                                    { label: 'False', value: 'false' }
                                                  ]}
                                                value={ticketParamValues[param.paramName]}
                                                onChange={(e) => handleParamChange(e, param.paramName, param.paramDataType)}
                                                required={param.mandatory}
                                                errorMessage={paramErrors[param.paramName]}
                                            />
                                        ) : (
                                            <TextInputField
                                                name={param.paramName}
                                                labelText={param.paramName}
                                                value={ticketParamValues[param.paramName] || ''}
                                                onChange={(e) => handleParamChange(e, param.paramName, param.paramDataType)}
                                                required={param.mandatory}
                                                errorMessage={paramErrors[param.paramName]}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                    ))}
                <div className="flex flex-column md:flex-row lg:flex-row col-12 pl-0 pt-0 mt-3 lg:justify-content-between md:justify-content-between">
                    <div className="flex flex-column col-12 md:col-10 lg:col-10 lg:mb-0 my-1">
                        <TextAreaField id="remarks-text-area" labelText="Description" name="ticketDescription" rows={6} onChange={(e) => handleChange(e)} value={ticketObj.ticketDescription} maxLength={1000} required />
                    </div>
                    <div className="flex flex-column col-12 md:col-2 lg:col-2 lg:mb-0 my-1 pb-0">
                        <label style={{ fontSize: '12px', marginBottom: '6px' }}>File Upload</label>
                        {
                            !ticketObj.ticketDocument ?
                                <div>
                                    <FileUpload mode="basic" name="ticketDocument" accept=".jpg,.jpeg,.png,.pdf,.csv,.xls,.xlsx" maxFileSize={5000000} customUpload uploadHandler={(files) => documentUploadHandler(files, "TICKET_DOCUMENT")} auto chooseLabel="Upload File" />
                                </div>
                                :
                                <div className='flex gap-1'>
                                    <FileViewAndRemove doc={{url:uploadedFile}} showRemove handleRemoveDoc={removeTicketDocument} />
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className="flex flex-row justify-content-center align-items-center mt-3">
                <Button  label="Add Ticket" onClick={(e) => saveTicket(e)} />
            </div>
            <Dialog  visible={uploadedFileView}  style={{ width: '80%', height: '80%', backgroundColor: '#f8f8f8', position:"" }}  onHide={() => setUploadedFileView(false)}>
                {/* <div style={{ width: "100%", height: '100%'}}> */}
                    <div className='image-dialog-container' style={{ width: "100%", height: '100%'}}>
                    {/* <img src={ticketObj.ticketDocument} width="1600" height="1000" /> */}
                    { 
                        ["png","jpeg", "jpg"].includes(ticketObj.ticketDocument) ? 
                            <img className='uploaded-image' src={ticketObj.ticketDocument} />
                            :
                            <embed className='uploaded-image' src={ticketObj.ticketDocument} width="100%" height="100%" />
                    }
                    </div>
                {/* </div> */}
            </Dialog>
            <Loading visible={isLoading} />
            </div>
        </div>
    )
}

export default TicketAdd